import ErrorAlert from 'components/shared/ErrorAlert';
import * as React from 'react';
import { WithTestIdOptional } from 'shared-client/types/test';
import { AutoSuggestDataRenderProps } from './AutoSuggestData';
import AutoSuggestMenu from './AutoSuggestMenu';
import { AutoSuggestRenderMenuProps } from './Types';

export interface AutoSuggestBaseProps extends WithTestIdOptional {
	data: AutoSuggestDataRenderProps;
	onCreateClick: () => Promise<void>;
	renderMenu: (props: AutoSuggestRenderMenuProps) => React.ReactNode;
}

/**
 * Renders everything that requires AutoSuggestData.
 *
 * @class AutoSuggestBase
 * @extends {React.Component<AutoSuggestBaseProps>}
 */
class AutoSuggestBase extends React.Component<AutoSuggestBaseProps> {
	public static defaultProps = {
		renderMenu: (props: AutoSuggestRenderMenuProps) => <AutoSuggestMenu {...props} />,
	};

	public render() {
		const { data, onCreateClick, renderMenu, testId } = this.props;

		if (data.errorStatus) {
			if (data.errorStatus === 403) {
				return (
					<ErrorAlert
						testId="error-alert"
						message="You do not have permission to view these values. Please contact an administrator."
						error={null}
					/>
				);
			}

			return <ErrorAlert error={null} />;
		}

		return renderMenu({ data: data, onCreateClick: onCreateClick, testId });
	}
}

export default AutoSuggestBase;
